/// <reference path="../../types.d.ts" />

import actionCreatorFactory from 'typescript-fsa';
import { asyncFactory } from 'typescript-fsa-redux-thunk';
import {
  DatasetFreshnessResponse,
  FilterOptionsResponse,
  fetchAutomationSummary,
  fetchDatasetFreshness,
  fetchFilterOptions
} from './api';

const ACTION_PREFIX = 'AUTOMATION_DASHBOARD';

const actionCreator = actionCreatorFactory();
const createAsync = asyncFactory<CMx.ApplicationState>(actionCreator);

export const setHealthSystem = actionCreator<string>(
  `${ACTION_PREFIX}/SET_HEALTH_SYSTEM`
);

export const setServiceLine = actionCreator<string>(
  `${ACTION_PREFIX}/SET_SERVICE_LINE`
);

export const setTenant = actionCreator<string>(`${ACTION_PREFIX}/SET_TENANT`);

export const setDateSelection = actionCreator<{
  presetId: string;
  dos_start: string;
  dos_end: string;
}>(`${ACTION_PREFIX}/SET_DATE_SELECTION`);

export const fetchSummary = createAsync<
  void,
  CMx.AutomationDashboardSummary,
  Error
>(`${ACTION_PREFIX}/FETCH_SUMMARY`, async (_, _dispatch, getState) => {
  const { filters, dateRange } = getState().automationDashboard;
  return fetchAutomationSummary({ ...filters, ...dateRange });
});

export const loadFilterOptions = createAsync<
  void,
  FilterOptionsResponse,
  Error
>(`${ACTION_PREFIX}/FETCH_FILTER_OPTIONS`, async () => fetchFilterOptions());

export const loadFreshness = createAsync<
  void,
  DatasetFreshnessResponse,
  Error
>(`${ACTION_PREFIX}/FETCH_FRESHNESS`, async () => fetchDatasetFreshness());

export const initializeDashboard = () => (dispatch: any) => {
  dispatch(loadFilterOptions());
  dispatch(loadFreshness());
  return dispatch(fetchSummary());
};

export const selectHealthSystemAndFetch = (code: string) => (
  dispatch: any
) => {
  dispatch(setHealthSystem(code));
  return dispatch(fetchSummary());
};

export const selectServiceLineAndFetch = (code: string) => (
  dispatch: any
) => {
  dispatch(setServiceLine(code));
  return dispatch(fetchSummary());
};

export const selectTenantAndFetch = (code: string) => (dispatch: any) => {
  dispatch(setTenant(code));
  return dispatch(fetchSummary());
};

export const selectDateSelectionAndFetch = (selection: {
  presetId: string;
  dos_start: string;
  dos_end: string;
}) => (dispatch: any) => {
  dispatch(setDateSelection(selection));
  return dispatch(fetchSummary());
};
